/**
 * @Description 机会点详情-开店区域概览-表单页集客点信息
 */

import React, { FC, useEffect, useMemo, useState } from 'react';
import { Row, Col, Form } from 'antd';
import { isArray, isNotEmptyAny } from '@lhb/func';
import V2FormSelect from '@/common/components/Form/V2FormSelect/V2FormSelect';
import { useSelector } from 'react-redux';
import { v4 } from 'uuid';
import { getDetail as getSpotDetail } from '@/common/api/sitemapgather';
import V2Title from '@/common/components/Feedback/V2Title';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';
import V2FormUpload from '@/common/components/Form/V2FormUpload/V2FormUpload';
import V2FormInputNumber from '@/common/components/Form/V2FormInputNumber/V2FormInputNumber';
import V2FormTextArea from '@/common/components/Form/V2FormTextArea/V2FormTextArea';
// import LinesInfo from '../LinesInfo';

import styles from './index.module.less';
import GatherClientDrawer, { EnterDrawerStateType, EnterDrawerTypeEnums } from '@/common/components/business/AreaDetailDrawer/components/GatherClientDrawer';

const PlanSpotFormItem: FC<any> = ({
  identification,
  form,
  formItemData = {},
  curCompValue,
  clusterId,
  disabled,
  setCustomGatheringCategoryForYHT,
}) => {
  // const [relationDetail, setRelationDetail] = useState<any>({}); // 集客点相关完整详情
  const [spotDetail, setSpotDetail] = useState<any>({}); // 选中集客点的详情
  const planSpotId = Form.useWatch(`${identification}-planSpotId`, form);
  const tenantCheckData = useSelector((state: any) => state.common.tenantCheck);
  const [gatherClientPointDrawer, setGatherClientPointDrawer] = useState<EnterDrawerStateType>({
    visible: false,
    value: {
      id: ''
    },
    // hasPlanSpot: null
  });// 集客点抽屉
  const [planSpotIdOptionObj, setPlanSpotIdOptionObj] = useState<{hasCreated: boolean, options:any[]}>({
    hasCreated: false, // 是否快速创建过
    options: []
  }); // 集客点选项
  /**
   * @description 是否益禾堂租户
   */
  const isYiHeTang = useMemo(() => {
    return tenantCheckData?.isYiHeTang;
  }, [tenantCheckData]);

  useEffect(() => {
    const textValue = JSON.parse(formItemData.textValue);
    if (textValue?.savePlanSpot && isNotEmptyAny(textValue.savePlanSpot)) {
      // console.log('savePlanSpot', savePlanSpot, curCompValue);

      const _options: { label: string; value: string|number }[] = (() => {
        const planSpots = curCompValue.planSpots || [];
        const savePlanSpot = textValue.savePlanSpot;

        const defaultOption = savePlanSpot?.planSpots?.[0];
        const additionalOption = defaultOption ? [{ label: defaultOption.name, value: defaultOption.name }] : [];

        return [
          ...planSpots.map((itm) => ({ label: itm.name, value: itm.id })),
          ...additionalOption
        ];
      })();
      setPlanSpotIdOptionObj({
        hasCreated: false,
        options: _options
      });
    } else {
      setPlanSpotIdOptionObj({
        ...planSpotIdOptionObj,
        options: Array.isArray(curCompValue.planSpots) ? curCompValue.planSpots.map(itm => ({ label: itm.name, value: itm.id })) : []
      });
    }
  }, [curCompValue]);


  /**
   * @description 初次渲染formItem信息
   */
  useEffect(() => {
    const modelClusterId = curCompValue?.clusterId;
    // console.log('planSpotId', planSpotId, modelClusterId, isYiHeTang, formItemData);
    const textValue = JSON.parse(formItemData.textValue);
    // 目前只有益禾堂租户需要展示集客点信息
    if (planSpotId && modelClusterId && typeof planSpotId !== 'string' && isYiHeTang) {
      getSpotDetail({ modelClusterId }).then((res: any) => {
        // isNotEmptyAny(res) && setRelationDetail(res);
        const tmpSpot = isArray(res?.planSpots) ? res?.planSpots.find((itm) => itm.id === planSpotId) : null;
        isNotEmptyAny(tmpSpot) && setSpotDetail(tmpSpot);
      });
    } else if (textValue?.savePlanSpot && isNotEmptyAny(textValue.savePlanSpot) && typeof planSpotId === 'string') {
      // console.log(`是这里吗2222`, textValue);
      // 如果有快捷创建的集客点信息，则取这里
      isNotEmptyAny(textValue.savePlanSpot?.planSpots?.[0]) && setSpotDetail(textValue.savePlanSpot.planSpots[0]);
    } else {
      // 移动商圈，planSpotId=null，走这里，会清空集客点信息
      setSpotDetail({});
    }
  }, [planSpotId, isYiHeTang]);

  useEffect(() => {
    if (isNotEmptyAny(spotDetail)) {
      form.setFieldsValue({
        [`${identification}-displayCategory`]: spotDetail.thirdLevelCategory || spotDetail.secondLevelCategory || spotDetail.firstLevelCategory || '-',
        [`${identification}-firstShop`]: spotDetail.firstShop,
        [`${identification}-secondShop`]: spotDetail.secondShop,
        [`${identification}-rent`]: spotDetail.rent,
        [`${identification}-assignmentFee`]: spotDetail.assignmentFee,
        [`${identification}-videoUrls`]: spotDetail.videoUrls,
        [`${identification}-videoRemark`]: spotDetail.videoRemark,
        [`${identification}-competitors`]: spotDetail.competitors,
        [`${identification}-landlords`]: spotDetail.landlords,
      });
    }
  }, [spotDetail]);

  /**
   * @description 集客点选择是否可点击
   *   这些情况下禁用：
   *   该定制组件配置为禁用、处在分享页(app端才有这种情况)、所选位置返回的集客点选项为空
   */
  const isPlanSpotsDisable = useMemo(() => {
    if (disabled) return true;
    if (planSpotIdOptionObj.hasCreated) return true;
    return !curCompValue || !Array.isArray(curCompValue?.planSpots) || !curCompValue?.planSpots.length;
  }, [curCompValue, planSpotIdOptionObj.hasCreated]);

  /**
   * @description 集客点选择变动--存入到textValue中
   * @param val 选项id
   * @param opt 选项
   * @return
   */
  const onPlanStoreChange = (val: any, opt) => {
    const value = JSON.parse(formItemData.textValue);
    const savePlanSpotName = value?.savePlanSpot?.planSpots?.[0]?.name || '';
    // 快速创建的集客点 id与值为手动设置相同
    if (opt?.value === savePlanSpotName) {
      const textValue = {
        ...value,
        planSpotName: opt?.label,
        planSpotId: null
      };
      value?.savePlanSpot && value.savePlanSpot?.firstLevelCategory && setCustomGatheringCategoryForYHT({
        firstLevelCategory: value.savePlanSpot.firstLevelCategory
      });
      formItemData.textValue = JSON.stringify(textValue);
      // 如果有快捷创建的集客点信息，则取这里
      isNotEmptyAny(textValue.savePlanSpot?.planSpots?.[0]) && setSpotDetail(textValue.savePlanSpot.planSpots[0]);
      return;
    };
    const textValue = {
      ...value,
      planSpotName: opt?.label,
      planSpotId: opt?.value
    };
    const { clusterId } = value;
    formItemData.textValue = JSON.stringify(textValue);
    if (!clusterId) return;
    // 这里是后加的逻辑，不想与已有的getSpotDetail里处理，因为useEffect里触发的无法区分驱动来源
    getSpotDetail({ modelClusterId: clusterId }).then((res: any) => {
      const { planSpots } = res || {};
      const tmpSpot = isArray(planSpots) ? planSpots.find((itm) => itm.id === opt?.value) : null;
      tmpSpot && setCustomGatheringCategoryForYHT({
        firstLevelCategory: tmpSpot?.firstLevelCategory
      });
    });
  };


  const createQuicklyEnter = () => {
    setGatherClientPointDrawer({
      ...gatherClientPointDrawer,
      visible: true,
      type: EnterDrawerTypeEnums.Quick,
      // hasPlanSpot: planSpotIdOptionObj.options.length > 0,
      value: {
        id: clusterId
      }
    });
  };

  const onQuicklyCreateCb = (data) => {
    // console.log('data', data);
    const uuid = v4();

    const value = JSON.parse(formItemData.textValue);
    const textValue = {
      ...value,
      planSpotName: data.planSpots[0]?.name || null,
      planSpotId: null,
      savePlanSpot: data
    };
    formItemData.textValue = JSON.stringify(textValue);

    const _options:any[] = Array.isArray(curCompValue.planSpots) && curCompValue.planSpots.length ? curCompValue.planSpots.map(itm => ({ label: itm.name, value: itm.id })).concat({ label: data.planSpots[0]?.name, value: uuid }) : [{ label: data.planSpots[0]?.name, value: uuid }];

    setPlanSpotIdOptionObj({
      hasCreated: true,
      options: _options
    });

    form.setFieldValue(`${identification}-planSpotId`, uuid);
    setCustomGatheringCategoryForYHT && setCustomGatheringCategoryForYHT({
      firstLevelCategory: textValue?.savePlanSpot?.firstLevelCategory
    });
    setSpotDetail(data.planSpots[0]);
  };

  /**
   * @description 集合点详情
   */
  const renderSpotRelation = () => {
    return <>
      {/* <Col span={24}>
        <Form.Item label='动线始末'>
          <LinesInfo
            detail={relationDetail}
            targetPlanSpotIds={[planSpotId]}
          />
        </Form.Item>
      </Col> */}
      <Col span={12}>
        <V2FormInput
          name={`${identification}-displayCategory`}
          label='商圈类型'
          disabled
        />
      </Col>
      <Col span={12}>
        <V2FormInput
          name={`${identification}-firstShop`}
          label='首选店铺'
          disabled
        />
      </Col>
      <Col span={12}>
        <V2FormInput
          name={`${identification}-secondShop`}
          label='次选店铺'
          disabled
        />
      </Col>
      <Col span={12}>
        <V2FormInputNumber
          name={`${identification}-rent`}
          label='租金单价行情'
          config={{ addonAfter: '㎡/月/元' }}
          disabled
        />
      </Col>
      <Col span={12}>
        <V2FormInputNumber
          name={`${identification}-assignmentFee`}
          label='转让费行情'
          config={{ addonAfter: '元' }}
          disabled
        />
      </Col>
      <Col span={12}>
        <V2FormUpload
          label='上传动线视频讲解'
          name={`${identification}-videoUrls`}
          uploadType='files'
          config={{ disabled: true }}
          tipConfig={{ tooltipIconShow: false }}
        />
      </Col>
      <Col span={12}>
        <V2FormTextArea
          name={`${identification}-videoRemark`}
          label='视频备注'
          disabled
        />
      </Col>
      <Form.List name={`${identification}-competitors`}>
        {fields =>
          fields.map((field: any, index: number) => (
            <React.Fragment key={field.key}>
              <Col span={24}>
                <V2Title
                  type='H2'
                  divider
                  text={fields.length > 1 ? `竞品信息${index + 1}` : '竞品信息'}
                  className={'mb-12'}/>
              </Col>
              <Col span={12}>
                <V2FormInput
                  name={[field.name, 'competitorName']}
                  label='竞品名称'
                  disabled
                />
              </Col>
              <Col span={12}>
                <V2FormInputNumber
                  name={[field.name, 'takeAwayCount']}
                  label='外卖月总单量'
                  config={{ addonAfter: '单' }}
                  disabled
                />
              </Col>
            </React.Fragment>
          ))
        }
      </Form.List>
      <Form.List name={`${identification}-landlords`}>
        {fields =>
          fields.map((field: any, index: number) => (
            <React.Fragment key={field.key}>
              <Col span={24}>
                <V2Title
                  type='H2'
                  divider
                  text={fields.length > 1 ? `店铺信息${index + 1}` : '店铺信息'}
                  className={'mb-12'}/>
              </Col>
              <Col span={12}>
                <V2FormInput
                  name={[field.name, 'landlordShopName']}
                  label='店铺名称'
                  disabled
                />
              </Col>
              <Col span={12}>
                <V2FormInput
                  name={[field.name, 'landlordName']}
                  label='联系人姓名'
                  disabled
                />
              </Col>
              <Col span={12}>
                <V2FormInput
                  name={[field.name, 'landlordMobile']}
                  label='联系方式'
                  disabled
                />
              </Col>
              <Col span={12}/>
            </React.Fragment>
          ))
        }
      </Form.List>
    </>;
  };
  return (
    <>
      <Row gutter={24} className={styles.planSpotFormItemCon}>
        <Col span={24}>
          <V2Title
            type='H2'
            divider
            text={'集客点信息'}
            className={'mb-12'}/>
        </Col>
        <Col span={12}>
          <V2FormSelect
            name={`${identification}-planSpotId`}
            // label='所在集客点'
            label={
              disabled ? '所在集客点' : <div className={styles.demoK1Label}>
                所在集客点
                <div className={styles.demoK1LabelRight} onClick={createQuicklyEnter}>去创建</div>
              </div>
            }
            rules={[{ required: !!formItemData.required, message: '请选择所在集客点' }]}
            // required={!!formItemData.required}
            disabled={isPlanSpotsDisable}
            config={{
              showArrow: !isPlanSpotsDisable
            }}
            options={planSpotIdOptionObj.options}
            placeholder={curCompValue && isArray(curCompValue.planSpots) && curCompValue.planSpots.length ? '请选择所在集客点' : '暂无集客点'}
            onChange={onPlanStoreChange}/>
        </Col>
        {isYiHeTang && isNotEmptyAny(spotDetail) ? renderSpotRelation() : <></>}
      </Row>
      <GatherClientDrawer
        open={gatherClientPointDrawer}
        setOpen={setGatherClientPointDrawer}
        onQuicklyCreateCb={onQuicklyCreateCb}
      />
    </>
  );
};

export default PlanSpotFormItem;
